<template lang="pug">
  b-container.content-wrap(fluid)
    b-container.d-flex.justify-content-between(fluid)
      .title
        span.page-title {{$t('user_page.department_member_management')}}

    b-row.search-form
      b-col
      b-col.right-btns
        b-btn.ml-2.view-mode-button(size="sm", :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}
          span(v-else) Download...

    b-card.table-card
      b-table(
        ref="userTable"
        :fields="tableData.fields"
        :items="fetchList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.per"
        :empty-text="$t('no-content')"
        tbody-class="lmm-table-body"
        sort-by="part_name"
        :sort-desc="false"
        show-empty
        responsive
      )
        //- body
        //- template(v-slot:cell(member_type_id)="row")
          icon(v-if="AppState.perm.isApprover && row.item.member_type_id === 6 || row.item.member_type_id === 2" name="user-cog", scale="1.5")
          icon(v-else-if="row.item.member_type_id === 7" name="handshake", scale="1.5")

        template(v-slot:cell(part_name)="row")
          b-btn(variant="link", :to="{name: 'user-edit-department', params: {id: row.item.pk}}") {{row.item.part_name}}
        
        template(v-slot:cell(leader_manager_name)="row")
          span(v-if="row.item.leader_manager_name === '-'") {{ row.item.leader_manager_name }}
          b-btn(v-else variant="link", :to="{name: 'edit-manager', params: {userPk: row.item.leader_manager_fk}}") {{row.item.leader_manager_name}}
        
        template(v-slot:cell(department_member_count)="row")
          b-btn(variant="link" @click="openDialogDepartmentUser(row.item)") {{row.item.department_member_count}}

        template(v-slot:cell(btn)="row")
          b-button.d-inline-flex(size="sm" :to="{name: 'user-edit-department', params: {id: row.item.pk}}") {{$t('setting')}}

    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm",
          v-model="tableData.pagination.per",
          :options="tableData.pagination.perOptions")
      b-pagination(
        size="sm",
        :total-rows="tableData.pagination.total",
        :per-page="tableData.pagination.per",
        v-model="tableData.pagination.current",
        class="my-0 float-right"
      )
    dialog-department-user(:show.sync="visibleDialogDepartmentUser" :pk="selectDepartmentPk")
</template>

<script>
import { DepartmentsAPI, GetMgridAPI } from "@/api"
import DialogDepartmentUser from "../components/dialogDepartmentUser.vue"
export default {
  components: {
    DialogDepartmentUser,
  },
  data() {
    return {
      excelLoaded: false,
      excelLink: null,
      visibleDialogDepartmentUser: false,
      selectDepartmentPk: null,

      tableData: {
        fields: [
          {
            key: "check",
            label: "",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: false,
            thStyle: { width: "1%" },
          },
          { key: "part_name", label: `${this.$t('department')} ${this.$t('manage')}`, sortable: true, thStyle: { minWidth: "100px" } },
          { key: "leader_manager_name", label: `${this.$t('user_page.department_head')}(${this.$t('mid_manager')})`, sortable: true, thStyle: { minWidth: "150px" } },
          { key: "department_member_count", label: this.$t('user_page.members'), sortable: true, thStyle: { minWidth: "70px" } },
          { key: "btn", label: this.$t('user_page.department_policy'), thStyle: { minWidth: "70px" } },
        ],
        list: [
          {
            pk: 1,
            userPk: 8427,
            name: "IT운영",
            submanager: "홍길동",
            count: 11,
          },
          {
            pk: 2,
            userPk: 8427,
            name: "인사",
            submanager: "최창민",
            count: 8,
          },
        ],
        pagination: {
          by: "part_name",
          limit: 24,
          offset: 0,
          order: "desc",
          search_mode: "pagination",

          total: 1,
          current: 1,
          per: 24,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },
    }
  },
  mounted() {
    // this.fetchList()
  },
  methods: {
    fetchList(ctx) {
      if (!ctx) return
      if (ctx.sortBy === "") return

      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
        search_mode: "pagination",
      }

      return DepartmentsAPI.get("", { params }).then(res => {
        this.tableData.list = res.data.objects

        return res.data.objects
      })
    },
    openDialogDepartmentUser(item) {
      this.selectDepartmentPk = item.pk
      this.visibleDialogDepartmentUser = true
    },
    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
        .then(params => {
          //전송용 임시 폼 엘리먼트 생성
          var form = document.createElement("form")
          form.method = "post"
          form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출

          // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
          let jsonData = {...params, language: this.$i18n.locale}
          var input = document.createElement("input")
          input.type = "hidden"
          input.name = "jsondata"
          input.value = JSON.stringify(jsonData)
          form.appendChild(input)

          // body에 폼 추가 및 제출 그 후 제거
          document.body.appendChild(form)
          form.target = "_blank"
          form.submit()
          document.body.removeChild(form)

          this.excelLoaded = false
        })
        .catch(err => {
          this.excelLoaded = false
          alert(this.$t('toasts_message.no_data_to_download_excel'))
        })
    },
    async fetchExcel() {
      if (this.tableData.pagination.total < 1) {
        throw new Error(this.$t('no_data_available'))
      }
      const list = await DepartmentsAPI.get("", {})
      const excelParams = list.data
      excelParams.excel_doc_title = `${this.$t('department')} ${this.$t('manage')}`

      //console.log(excelParams.objects)
      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "user_depart"
      excelParams_for_download.excel_doc_title = `${this.$t('department')} ${this.$t('manage')}`

      return excelParams_for_download
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input = excelParams.objects
      let output = []
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [`${this.$t('department')} ${this.$t('name')}`]: input[index]["part_name"],
          [this.$t('user_page.department_head')]: this.nullcheck(input[index]["leader_manager_name"]),
          [this.$t('user_page.members')]: input[index]["department_member_count"],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },
  },
}
</script>

<style lang="scss" scoped>
svg {
  color: #ababab;
}
</style>
